var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content dash",staticStyle:{"width":"100%","overflow":"auto"}},[_c('b-container',{attrs:{"fluid":""}},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"mt-3"},[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }